import React, { Component } from "react";
import PropTypes from "prop-types";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import s from "./FaqAccordian.css";
import { connect } from "react-redux";
import { getHostFaqs } from "../../actions/getHostFaqs";
import { PanelGroup, Panel } from "react-bootstrap";
import imageOne from "../../../public/SiteImages/warrow.png";
import messages from "../../locale/messages";
import { injectIntl } from "react-intl";

class FaqAccordian extends Component {
  static propTypes = {
    formatMessage: PropTypes.any,
  };

  state = {
    activeKey: "0", // default open panel
  };

  componentDidMount() {
    this.props.getHostFaqs();
  }

  handleSelect = (activeKey) => {
    this.setState({ activeKey });
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { items, description } = this.props;
    const { activeKey } = this.state;

    return (
      <div className="pt-67 faq-maxwdth">
        {/* Heading Section */}
        <div>
          <h2 className="fw-bold">{formatMessage(messages.faqs)}</h2>
          <p
            style={{ fontSize: "16px", lineHeight: "1.6" }}
            className={s.contentColor}
          >
            {description?.value}
          </p>
        </div>

        {/* FAQ Accordion */}
        <PanelGroup
          accordion
          id="accordion"
          className="faq-accordian"
          activeKey={activeKey}
          onSelect={this.handleSelect}
        >
          {items?.map((item, index) => (
            <Panel eventKey={String(index)} key={index}>
              <Panel.Heading>
                <Panel.Title toggle>
                  {item.title} <img src={imageOne}></img>
                </Panel.Title>
              </Panel.Heading>
              <Panel.Body collapsible className={s.contentColor}>
                {item.content}
              </Panel.Body>
            </Panel>
          ))}
        </PanelGroup>
      </div>
    );
  }
}

FaqAccordian.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
    })
  ).isRequired,
  getHostFaqs: PropTypes.func.isRequired,
};

const mapState = (state) => {
  const rawItems = state?.faqs?.dataList || [];
  const items = rawItems.map((faq) => ({
    title: faq.question,
    content: faq.answer,
  }));
  const description = state?.faqs?.faqDescription || "";
  return {
    items,
    description,
  };
};

const mapDispatch = {
  getHostFaqs,
};

export default injectIntl(
  withStyles(s)(connect(mapState, mapDispatch)(FaqAccordian))
);
